import { HttpContextBase as HttpContextBase } from '@shared/enums';

export const createRouteContextObject = <
  E extends Record<string, string | number>
>(
  httpContext: HttpContextBase,
  original: E
): { [K in keyof E]: string } => {
  return Object.keys(original).reduce((acc, key) => {
    // Check if the key is numeric and skip it (otherwise for enums results in duplicate key/value instead of just key)
    if (!isNaN(Number(key))) {
      return acc;
    }

    acc[key] = `${HttpContextBase[httpContext]}__${key}`;
    return acc;
  }, {}) as { [K in keyof E]: string };
};
